import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Button } from '@fluentui/react-components';

const useStyles = makeStyles({
 bubbleContainer: {
  border: '1px solid #4ade80', // Green border matching screenshot
  backgroundColor: '#f4fbf4',  // Light green background
  borderRadius: '12px',
  padding: '16px',
  width: '100%',
  maxWidth: '650px',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  fontFamily: 'Arial, sans-serif',
  boxShadow: '0 2px 6px rgba(0,0,0,0.05)'
 },
 articleBlock: {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
 },
 title: {
  fontSize: '14px',
  color: '#0056b3', // Link blue
  fontWeight: 'normal',
  cursor: 'pointer',
  marginBottom: '2px',
  textDecoration: 'none',
  ':hover': { textDecoration: 'underline' },
  // Ensures <strong> tags inside dangerouslySetInnerHTML remain blue and bold
  '& strong': { color: '#0056b3', fontWeight: 'bold' } 
 },
 authors: {
  fontSize: '12px',
  color: '#333',
 },
 journalInfo: {
  fontSize: '11px',
  color: '#666',
 },
 metaRow: {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  fontSize: '11px',
  marginTop: '2px'
 },
 pmid: { color: '#666' },
 freeText: { color: '#d97706', fontWeight: '600' }, // Orange text
 reviewText: { color: '#666' },
 snippet: {
  fontSize: '12px',
  color: '#333',
  marginTop: '4px',
  lineHeight: '1.5',
  '& strong': { fontWeight: 'bold', color: '#000' } // Bolded search terms
 },
 showMoreBtn: {
  alignSelf: 'flex-end',
  backgroundColor: '#ffffff',
  border: '1px solid #ccc',
  color: '#333',
  fontSize: '11px',
  padding: '4px 12px',
  height: 'auto',
  minHeight: 'auto',
  borderRadius: '4px',
  fontWeight: '600',
  ':hover': { backgroundColor: '#f5f5f5' }
 }
});

const RomineResultsBubble = ({ articles }) => {
 const styles = useStyles();

 if (!articles || articles.length === 0) return null;

 return (
  <div className={styles.bubbleContainer}>
   {articles.map((article, index) => (
    <div key={article.id} className={styles.articleBlock}>
     
     {/* Title with injected bold highlights */}
     <div 
      className={styles.title}
      dangerouslySetInnerHTML={{ __html: `${index + 1}. ${article.title}` }}
     />
     
     <div className={styles.authors}>{article.authors}</div>
     <div className={styles.journalInfo}>{article.journalInfo}</div>
     
     {/* Meta info row: PMID, Free Article status, etc. */}
     <div className={styles.metaRow}>
      <span className={styles.pmid}>PMID: {article.pmid}</span>
      {article.isFree && <span className={styles.freeText}>Free PMC article.</span>}
      {article.isReview && <span className={styles.reviewText}>Review.</span>}
     </div>
     
     {/* Snippet with injected bold highlights */}
     <div 
      className={styles.snippet}
      dangerouslySetInnerHTML={{ __html: article.snippet }}
     />
    </div>
   ))}
   
   <Button className={styles.showMoreBtn}>
    Show more results
   </Button>
  </div>
 );
};

RomineResultsBubble.propTypes = {
 articles: PropTypes.array.isRequired
};

export default RomineResultsBubble;